<script setup lang="ts">
import { TooltipContent, TooltipPortal, TooltipRoot, TooltipTrigger } from "reka-ui";

/**
 * Design-system primitive: tokens only, no business knowledge, no network.
 *
 * A frase curta que explica um controle sem ocupar a tela.
 *
 * ── O QUE ISTO SUBSTITUI, E POR QUE ──────────────────────────────────────
 *
 * 47 atributos `title=` nativos, em 34 arquivos. O `title` do navegador tem três
 * defeitos que não se conserta com CSS: ele demora cerca de um segundo e meio a
 * aparecer, ele NÃO aparece para quem navega por teclado (só no hover do ponteiro),
 * e ele é cortado ou reposicionado pelo sistema operacional sem que a página possa
 * opinar. Isto abre em 300ms, abre também no foco, sai por portal e desvia da borda
 * da janela.
 *
 * ── ELE DESCREVE, ELE NÃO NOMEIA ─────────────────────────────────────────
 *
 * O `TooltipTrigger` liga o texto por `aria-describedby`. Quem envolve um botão de
 * ícone continua devendo um `aria-label`: o `title` fazia os dois papéis por
 * acidente, e trocar um `title` que era o ÚNICO nome por um tooltip deixaria o
 * botão sem nome nenhum.
 *
 * Depende do `TooltipProvider` montado uma vez no `App.vue`, acima do ramo `bare`
 * — as telas públicas (formulário, chat, documento) também têm controles.
 */
withDefaults(
	defineProps<{
		text: string;
		side?: "top" | "bottom" | "left" | "right";
		/**
		 * Aberto por quem usa, quando o foco não está no gatilho (a linha de uma
		 * árvore com foco itinerante). Ausente, abre sozinho no hover e no foco.
		 */
		open?: boolean;
	}>(),
	{ side: "top", open: undefined },
);
</script>

<template>
	<TooltipRoot :open="open">
		<TooltipTrigger as-child>
			<slot />
		</TooltipTrigger>
		<TooltipPortal>
			<TooltipContent
				class="z-[70] max-w-64 rounded-lg bg-fg px-2 py-1 text-2xs leading-relaxed text-bg shadow-lg"
				:side="side"
				:side-offset="6"
				:collision-padding="8"
			>
				{{ text }}
			</TooltipContent>
		</TooltipPortal>
	</TooltipRoot>
</template>
